import {AppPageContainer} from 'views/Containers'
import React from 'react'
import services from 'services'
import requiresLoggedIn from 'views/hoc/loggedIn'
import ProjectContext from 'views/hoc/ProjectContext'
import {Col, Row} from 'components/Display'
import {usePublished} from 'utils/published'
import List from 'components/List'
import i18n from 'i18n'

function EmptyProjectView() {
  const projectsService = services.getProjectsService()
  const availableProjects = usePublished(projectsService.projects)
  return (
    <AppPageContainer>
      <ProjectContext>
        {(context) => {
          return (
            <Col className="flex-1">
              <div className="px-8 py-4 shadow text-4xl font-bold">{i18n.t('projectContext.placeholder')}</div>
              <Col className="flex-1">
                <List items={availableProjects}>
                  {(item) => {
                    const project = item.data
                    return (
                      <Row>
                        <Col className="flex-1" />
                        <Col
                          onClick={() => services.router.selectProject(project.id)}
                          className={`
                          flex-1 font-medium
                          shadow cursor-pointer px-2 py-4 border rounded mb-4 transition duration-100
                          hover:shadow-lg hover:text-white hover:bg-itx-primary-3
                          ${item.index === 0 ? 'mt-4' : ''}
                        `}
                        >
                          {project.name}
                        </Col>
                        <Col className="flex-1" />
                      </Row>
                    )
                  }}
                </List>
              </Col>
            </Col>
          )
        }}
      </ProjectContext>
    </AppPageContainer>
  )
}

export default requiresLoggedIn(EmptyProjectView)
